import { useEffect, useState } from 'react';
import { fetchSettings } from 'store/redux/settings';
import { useAppDispatch } from 'store/redux/use-app-dispatch';

type UseFastMaintenanceSettingsResult = {
  isEnabled: boolean;
};

export function useFastMaintenanceSettings(): UseFastMaintenanceSettingsResult {
  // `useAppDispatch` rather than `useDispatch`: `clientMiddleware` resolves a
  // `promise` action to the client's result, which is what the settings read is of.
  const dispatch = useAppDispatch();
  const [isEnabled, setIsEnabled] = useState(false);

  useEffect(() => {
    async function getSettings() {
      try {
        const { commerceSettings } = await dispatch(fetchSettings());
        const isDailyBillingEnabled =
          commerceSettings?.featureFlagsSettings?.isDailyBillingEnabled;
        setIsEnabled(isDailyBillingEnabled);
      } catch (err) {
        console.error(err);
      }
    }

    getSettings();
  }, [dispatch]);

  return {
    isEnabled,
  };
}
